import { type ComponentType } from 'react';
import { getPlatformComponent } from '@direct-frontend/platform-code';
import { type DashboardSidebarProps } from './lib/types';

export const DashboardSidebar = getPlatformComponent<ComponentType<DashboardSidebarProps>>({
    desktop: import('./DashboardSidebar@desktop'),
    mobile: import('./DashboardSidebar@mobile'),
});
